import * as Yup from 'yup';

export const ListTemplateValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nama Daftar Belanja Harus di Isi')
    .label('Nama Daftar Belanja')
    .max(32, 'Panjang Maksimum 32 Karakter'),
  note: Yup.string().label('Catatan').max(100, 'Panjang Maksimum 100 Karakter'),
});
